import { useState } from 'react';
import { SearchIcon, CloseIcon, ArrowRightIcon } from './icons';

export function SearchBar({ onSearch, loading }) {
  const [query, setQuery] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    onSearch(q);
    e.currentTarget.querySelector('input').blur(); // cierra el teclado en móvil para ver resultados
  };

  // iOS no siempre deja el input a la vista al abrir el teclado (el scroll suave global de html interrumpe
  // su auto-scroll), así que lo subimos nosotros cuando el teclado terminó de abrirse.
  const handleFocus = (e) => {
    const form = e.currentTarget.form;
    const vv = window.visualViewport;
    let done = false;
    const reveal = () => {
      if (done) return;
      done = true;
      vv?.removeEventListener('resize', reveal);
      form.scrollIntoView({ block: 'start', behavior: 'instant' });
    };
    vv?.addEventListener('resize', reveal);
    setTimeout(reveal, 400); // sin visualViewport o si el teclado ya estaba abierto
  };

  return (
    <form role="search" onSubmit={handleSubmit}
          className="relative scroll-mt-[calc(5rem+env(safe-area-inset-top))]">
      <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-lounge-stone" />
      <input
        type="search"
        enterKeyHint="search"
        aria-label="Buscar canción o artista"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={handleFocus}
        placeholder="Canción o artista"
        className="h-12 w-full rounded border border-lounge-line bg-lounge-chassis pl-12 pr-24 font-inter
                   text-base text-lounge-text caret-lounge-brass shadow-[inset_0_1px_3px_rgba(0,0,0,0.5)]
                   outline-none transition-colors placeholder:text-lounge-stone focus:border-lounge-brass
                   [&::-webkit-search-cancel-button]:appearance-none"
      />
      <div className="absolute right-0.5 top-1/2 flex -translate-y-1/2 items-center">
        {query && !loading && (
          <button
            type="button"
            aria-label="Limpiar búsqueda"
            onClick={() => setQuery('')}
            className="flex h-11 w-11 items-center justify-center rounded-full text-lounge-stone
                       transition-colors hover:text-lounge-text focus-visible:outline-none
                       focus-visible:ring-2 focus-visible:ring-lounge-brass"
          >
            <CloseIcon className="h-4 w-4" />
          </button>
        )}
        {/* Botón visible: en el celular no todos ven que Enter busca */}
        <button
          type="submit"
          aria-label="Buscar"
          disabled={loading}
          className="flex h-11 w-11 items-center justify-center rounded bg-lounge-brass text-lounge-base
                     transition-colors hover:bg-amber active:scale-[0.98] focus-visible:outline-none
                     focus-visible:ring-2 focus-visible:ring-lounge-brass focus-visible:ring-offset-2
                     focus-visible:ring-offset-lounge-base"
        >
          {loading ? (
            <span
              role="status"
              aria-label="Buscando"
              className="h-4 w-4 animate-spin rounded-full border-2 border-lounge-base border-t-transparent"
            />
          ) : (
            <ArrowRightIcon className="h-5 w-5" />
          )}
        </button>
      </div>
    </form>
  );
}
